import { colors, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  },
  root: {
    padding: theme.spacing(2),
    outline: 'none',
  },
  contentPaper: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    paddingBlock: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(2),
  },
  receiptTitleBox: {
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(3),
    borderBottom: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  statusLabelAuthorized: {
    color: theme.palette.statusLabel.success.primary,
    backgroundColor: theme.palette.statusLabel.success.secondary,
    fontWeight: 600,
  },
  statusLabelRevoked: {
    color: theme.palette.statusLabel.error.primary,
    backgroundColor: theme.palette.statusLabel.error.secondary,
    fontWeight: 600,
  },
  formTitleBox: {
    backgroundColor: theme.palette.greenSnowFlurry,
  },
  buttonError: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  consentDetailsContainer: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(3),
  },
  consentDetailsButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    gridGap: theme.spacing(2),
    width: '100%',
    justifyContent: 'end',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  consentDetailsButton: {
    width: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  optionsButton: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    color: colors.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
  scrollbar: {
    paddingRight: theme.spacing(2),
  },
  detailsItemBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 85,
    padding: theme.spacing(2),
  },
}))

export default useStyles
